import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { clearError, getRolesData, mfaLoginError, signIn } from '../../store/actions/User';
import NeatcarButton from "../../components/NeatcarButton";
import neatcarLogo from '../../assets/images/neatcar-logo.png';

const Login = () => {
  const { register, handleSubmit, formState: { errors }, setValue } = useForm();
  const [loginError, setLoginError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('login');

  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();
  const { user, authenticated, rolesLoading, roles ,error, userCredentialsForMFA } = useSelector(store => store.session);

  useEffect(() => {
    setLoading(false);
    if (error) {
      setLoginError(true);
      dispatch(mfaLoginError());
      dispatch(clearError());
      navigate('/');
    } else {
      if (authenticated) {
        // Dispatch getRolesData and wait for it to complete
        dispatch(getRolesData());
      }

      if (authenticated && roles && roles.length > 0) {
        const defaultRoute = roles.find(role => role.role === "ROLE_BUSINESS") ? "/team" : "/Insurer";
        const from = location.state?.from?.pathname || defaultRoute;
        navigate(from, { replace: true });
      } 
    }
  }, [authenticated,user, error, dispatch, location, navigate, roles]);

  useEffect(()=>{

    if(roles && rolesLoading == false){

    }


  },[rolesLoading])

  const onSubmit = (data) => {
    setLoading(true);
    setLoginError(false);
    dispatch(signIn(userCredentialsForMFA.login, userCredentialsForMFA.password, userCredentialsForMFA.rememberMe, data.totpCode));
  }

  return (
    <>
      <div className="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <img
            className="mx-auto h-12 w-auto"
            src={neatcarLogo}
            alt="Workflow"
          />
        </div>

        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
            <div className={'text-center py-4 mb-4'}>
              <h1 className={'text-2xl font-bold whitespace-pre-line'}>{t('mfaTitle')}</h1>
              <h3 className={'text-sm text-gray-400'}>{t('mfaSubtitle')}</h3>
            </div>
            <form className="space-y-6" onSubmit={handleSubmit(onSubmit)}>
              <div>
                <label htmlFor="totpCode" className="block text-sm font-medium text-gray-700">
                  {t('totpCode') || 'TOTP Code'}
                </label>
                <div className="mt-1">
                  <input
                    {...register("totpCode", { 
                      required: { value: true, message: t('required') }, 
                      pattern: { 
                        value: /^\d{6}$/, 
                        message: t('invalidTotpCode') || 'Please enter a 6-digit code' 
                      },
                      maxLength: {
                        value: 6,
                        message: t('invalidTotpCode') || 'Code must be 6 digits'
                      },
                      minLength: {
                        value: 6,
                        message: t('invalidTotpCode') || 'Code must be 6 digits'
                      }
                    })}
                    id="totpCode"
                    name="totpCode"
                    type="text"
                    inputMode="numeric"
                    maxLength="6"
                    autoComplete="one-time-code"
                    placeholder="000000"
                    className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-neatcar focus:border-neatcar sm:text-sm text-center text-2xl tracking-widest"
                    onInput={(e) => {
                      // Only allow digits and limit to 6
                      const value = e.target.value.replace(/\D/g, '').slice(0, 6);
                      e.target.value = value;
                      setValue('totpCode', value, { shouldValidate: true });
                    }}
                  />
                  {!loginError && (<span className="error">{errors.totpCode?.message}</span>)}
                  {loginError && (<span className="error">{t('wrongCredentials')}</span>)}
                </div>
              </div>

              <div>
                <NeatcarButton
                  type={'submit'}
                  loading={loading}
                  title={t('signIn')}
                />
              </div>
              <a onClick={() => navigate('/')} className={'text-neatcar cursor-pointer mt-2 text-center block'}>{t('backToLogin')}</a>
            </form>

          </div>
        </div>
      </div>
    </>
  )
}

export default Login;
